import { formatCases } from "../../views/orders/orderDetailsHelpers";

const CARDS = [
  { key: "ordered_cases", label: "Ordered Cases" },
  { key: "shipped_cases", label: "Shipped Cases" },
  { key: "returned_cases", label: "Returned Cases" },
  { key: "remaining_cases", label: "Remaining Cases" },
];

export default function OrderFulfillmentSummaryCards({ summary }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {CARDS.map(({ key, label }) => (
        <div
          key={key}
          className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
        >
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            {label}
          </p>
          <p className="mt-2 text-2xl font-bold text-slate-900">
            {formatCases(summary?.[key] ?? 0)}
          </p>
        </div>
      ))}
    </div>
  );
}
